(() => {
  const WIDGET_SELECTOR = '.jdgm-review-widget';
  const CARD_SELECTOR = '.jm-review-item[review-uuid]';
  let scheduled = false;

  const metadataByUuid = () => {
    const records = new Map();

    document.querySelectorAll('.jdgm-review-widget-data').forEach((script) => {
      const source = script.textContent || '';
      const assignment = source.match(/reviewWidget\[[^\]]+\]\s*=\s*(\{[\s\S]*\})\s*$/);
      if (!assignment) return;

      try {
        const payload = JSON.parse(assignment[1]);
        [...(payload.photo_gallery || []), ...(payload.reviews || [])].forEach((review) => {
          if (review && review.uuid) records.set(review.uuid, review);
        });
      } catch (_) {
        // Judge.me owns this payload. If its format changes, leave the review unlabelled.
      }
    });

    return records;
  };

  const addBadge = (card, label, modifier) => {
    const reviewerLine = card.querySelector('.jm-reviewer-info__details > .jm-cluster');
    if (!reviewerLine || reviewerLine.querySelector('.pd-review-badge--' + modifier)) return;

    const badge = document.createElement('span');
    badge.className = 'pd-review-badge pd-review-badge--' + modifier;

    if (modifier === 'verified' && label === 'Verified by shop') {
      const image = document.createElement('img');
      image.src = 'https://judgeme-public-images.imgix.net/judgeme/verified-badge-v2/verified-by-shop_light.svg';
      image.alt = 'Verified by Shop';
      image.width = 97;
      image.height = 20;
      badge.appendChild(image);
    } else {
      badge.textContent = label;
    }

    reviewerLine.appendChild(badge);
  };

  const enhance = () => {
    scheduled = false;
    const records = metadataByUuid();

    document.querySelectorAll(WIDGET_SELECTOR).forEach((widget) => {
      widget.querySelectorAll(CARD_SELECTOR).forEach((card) => {
        const uuid = card.getAttribute('review-uuid');
        const review = records.get(uuid);
        const hasMedia = Boolean(
          card.querySelector('.jm-media-thumbnail-list__thumbnail, .jm-media-preview, [aria-label="View review image"]') ||
          (review && ((review.pictures_urls || []).length || (review.video_external_ids || []).length))
        );

        if (hasMedia) {
          card.classList.add('pd-review-has-media');
        }

        card.classList.add('pd-review-is-verified');
        addBadge(card, 'Verified by shop', 'verified');

        const reviewContent = card.querySelector('.jm-review-content');
        if (reviewContent && !reviewContent.querySelector('.pd-review-shop-note')) {
          const note = document.createElement('div');
          note.className = 'pd-review-shop-note';
          note.textContent = 'Review verified by shop';
          reviewContent.appendChild(note);
        }
      });
    });
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(enhance);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
